import type { ParticipantFieldGroup } from '@piccolohealth/pbs-common';
import { ChakraV3, Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { ProfileItem } from '../../components/generic/ProfileItem';
import { gridItemSize } from '../../utils/gridItemSize';
import { ParticipantFieldValue } from './ParticipantFieldValue';

interface Props {
  fieldGroup: ParticipantFieldGroup;
}

export const ParticipantProfileCardFieldGroup = (props: Props) => {
  const { fieldGroup } = props;

  const content = P.run(() => {
    if (P.isEmpty(fieldGroup.fields)) {
      return <Empty title='No fields found' />;
    }

    return (
      <FormSection heading={fieldGroup.template.name}>
        <ChakraV3.Grid w='full' templateColumns='repeat(2, 1fr)' gap={4} rowGap={6}>
          {fieldGroup.fields.map((field) => (
            <ProfileItem
              key={field.id}
              label={`${field.template.name}`}
              colSpan={gridItemSize(field.template.type)}
            >
              <ParticipantFieldValue field={field} />
            </ProfileItem>
          ))}
        </ChakraV3.Grid>
      </FormSection>
    );
  });

  return (
    <ChakraV3.Tabs.Content
      value={`${fieldGroup.template.name}-${fieldGroup.template.index}`}
      key={`${fieldGroup.id}`}
    >
      {content}
    </ChakraV3.Tabs.Content>
  );
};
